module.exports = __webpack_public_path__ + "img/2025-meichu-prep-logo.21b83db8.png";